import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { createGTMTracking, getGTMAttributes } from '../../utils/gtm/gtm-tracking';
import { FreeTrialButton } from './FreeTrialButton';

export const ContactSectionV2: React.FC = () => {
  const { t } = useTranslation('marketing');
  return (
    <motion.section
      id="contact"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.8 }}
      className="flex w-full flex-col items-center bg-white"
      {...getGTMAttributes(createGTMTracking('SECTION_VIEWED', { origin: 'welcome_page', target: 'contact' }))}
    >
      <div className="flex flex-col items-start w-full px-4 sm:px-6 md:px-8 lg:px-12 py-10 sm:py-16 md:py-20 lg:py-[120px]">
        <div className="flex w-full flex-col lg:flex-row justify-between items-center gap-6 sm:gap-8 lg:gap-12 bg-[#F6F6F6] mx-auto my-0 p-6 sm:p-8 md:p-10 lg:p-16 rounded-[20px] sm:rounded-[30px] lg:rounded-[40px]">
          {/* Left: Title + No credit card */}
          <motion.div
            initial={{ opacity: 0, x: -8 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.05 }}
            transition={{ duration: 0.4 }}
            className="flex flex-col gap-3 text-center lg:text-left"
          >
            <h1 className="text-dark-invirtus text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold">
              {t('contact.title')}
            </h1>
            <p className="text-dark-invirtus/50 text-base sm:text-lg font-medium">
              {t('contact_v2.no_card')}
            </p>
          </motion.div>

          {/* Right: CTA */}
          <motion.div
            initial={{ opacity: 0, x: 8 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.05 }}
            transition={{ duration: 0.4, delay: 0.05 }}
            className="flex-shrink-0"
          >
            <FreeTrialButton origin="contact_section" />
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};
